import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";
import Home from "@/pages/Home";
import AppShell from "@/components/AppShell";
import Portfolio from "@/pages/Portfolio";
import Collections from "@/pages/Collections";
import CollectionDetail from "@/pages/CollectionDetail";
import { Toaster } from "sonner";

// Wrapper that renders the shared AppShell chrome (top/bottom nav) around its Outlet.
// The root "/" scanner route intentionally stays outside AppShell so the cinematic
// Pokéball hero remains edge-to-edge.
function ShellLayout() {
  return (
    <AppShell>
      <Outlet />
    </AppShell>
  );
}

function App() {
  return (
    <div className="App bg-obsidian min-h-screen">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route element={<ShellLayout />}>
            <Route path="/portfolio" element={<Portfolio />} />
            <Route path="/collections" element={<Collections />} />
            <Route path="/collections/:id" element={<CollectionDetail />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster theme="dark" position="top-center" richColors />
    </div>
  );
}

export default App;
